import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { FORTA_GRAY4, FORTA_ORANGE, FORTA_WHITE } from '../../../../../utils/colors';

interface IUnsavedIndicatorProps {
  fontSize?: number;
  title?: string;
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  borderRadius?: string;
  sx?: SxProps<Theme>;
}

function UnsavedIndicator({
  title,
  top,
  left,
  bottom = undefined,
  fontSize = 12,
  right = '-25px',
  sx = {},
}: IUnsavedIndicatorProps) {
  return (
    <Typography
      sx={{
        position: 'absolute',
        top: top ?? '-10px',
        right: right,
        left: left,
        bottom: bottom,
        fontSize,
        background: FORTA_GRAY4,
        color: FORTA_WHITE,
        border: `1px solid ${FORTA_ORANGE}`,
        boxSizing: 'border-box',
        px: 1,
        borderRadius: '10px',
        fontWeight: 700,
        zIndex: 100,
        ...sx,
      }}
    >
      {title ? title : 'Unsaved'}
    </Typography>
  );
}

export default UnsavedIndicator;
